<template>
  <div>
    <button class="small-margin-right" @click="block_product()">Block all variants</button>
    <button @click="unblock_product()">Unblock all variants</button>
    <Table :columns="block_tab_columns" :rows="block_tab_rows" />
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  props: [
    'variants',
    'product_id'
  ],
  data: () => ({
    block_tab_columns: {
      id: {},
      sku: {},
      ean: {},
      is_blocked: {}
    }
  }),
  computed: {
    block_tab_rows () {
      const variants = []
      for (const i in this.variants) {
        const currentVariant = this.variants[i]
        currentVariant.menu = []
        const blockButton = {
          name: 'Block',
          onClick: row => this.block_variant(row)
        }
        const unblockButton = {
          name: 'Unblock',
          onClick: row => this.unblock_variant(row)
        }
        if (currentVariant.is_blocked) {
          currentVariant.menu.push(unblockButton)
        } else {
          currentVariant.menu.push(blockButton)
        }
        variants.push(currentVariant)
      }
      return variants
    }
  },
  methods: {
    block_product () {
      Vue.$api.post('/product/' + this.product_id + '/block', {}, {
        callback: () => this.$router.go()
      })
    },
    unblock_product () {
      Vue.$api.post('/product/' + this.product_id + '/unblock', {}, {
        callback: () => this.$router.go()
      })
    },
    block_variant (row) {
      Vue.$api.post('/variant/' + row.id + '/block', {}, {
        callback: () => this.$router.go()
      })
    },
    unblock_variant (row) {
      Vue.$api.post('/variant/' + row.id + '/unblock', {}, {
        callback: () => this.$router.go()
      })
    }
  }
}
</script>

<style scoped>

</style>
